import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';
import DateInput from '../../ui/DateInput';

// MediaCaptureForm — pulls the shoot window (start date & time + duration,
// mirroring the portal media booking form) out of the generic renderer so a
// "TBD" checkbox can sit alongside it. When TBD is checked the window inputs
// hide and the payload carries `shoot_date_tbd: true`. With a window AND an
// assignee, the server reserves the photographer on the shared calendar.
const DURATIONS = ['1', '1.5', '2', '2.5', '3', '3.5', '4'];
const inputCls = 'w-full px-3 py-2 rounded-lg bg-white/[0.04] border border-white/[0.08] text-sm text-white';

export default function MediaCaptureForm({ values, onChange, errors }) {
  const fullSchema = projectTransitionSchema('media_capture');
  const otherFields = {
    ...fullSchema,
    fields: fullSchema.fields.filter((f) => f.key !== 'shoot_start_at' && f.key !== 'shoot_duration_hours'),
  };
  const tbd = !!values?.shoot_date_tbd;
  const start = values?.shoot_start_at || '';
  const duration = values?.shoot_duration_hours || '2';

  const setTbd = (next) => {
    if (next) onChange({ ...values, shoot_date_tbd: true, shoot_start_at: '', shoot_duration_hours: '' });
    else onChange({ ...values, shoot_date_tbd: false, shoot_duration_hours: values?.shoot_duration_hours || '2' });
  };
  const setStart = (v) => onChange({ ...values, shoot_start_at: v, shoot_duration_hours: values?.shoot_duration_hours || '2', shoot_date_tbd: false });
  const setDuration = (v) => onChange({ ...values, shoot_duration_hours: v });

  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="pfield-shoot_start_at" className="block text-[11px] uppercase tracking-wider text-gray-400/80 mb-1.5">
          Shoot window
        </label>
        {!tbd && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <DateInput
              id="pfield-shoot_start_at"
              data-testid="pfield-shoot_start_at"
              withTime
              value={start}
              onChange={setStart}
              className={inputCls}
            />
            <select
              id="pfield-shoot_duration_hours"
              data-testid="pfield-shoot_duration_hours"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              className={inputCls}
            >
              {DURATIONS.map((d) => <option key={d} value={d}>{d} hour{d === '1' ? '' : 's'}</option>)}
            </select>
          </div>
        )}
        {!tbd && (
          <p className="mt-1 text-[11px] text-gray-500">Coverage is capped at 4 hours. With an assignee set, this window is held on the photographer's calendar.</p>
        )}
        <label className="inline-flex items-center gap-2 text-[12px] text-gray-300 mt-2">
          <input
            type="checkbox"
            data-testid="pfield-shoot_date_tbd"
            checked={tbd}
            onChange={(e) => setTbd(e.target.checked)}
            className="accent-[#B0FC38]"
          />
          <span>Shoot date TBD</span>
        </label>
        {(errors?.shoot_start_at || errors?.shoot_date) && (
          <p className="mt-1 text-[11px] text-red-400" data-testid="pfield-shoot_start_at-error">{errors.shoot_start_at || errors.shoot_date}</p>
        )}
      </div>
      <ProjectTransitionFields schema={otherFields} values={values} onChange={onChange} errors={errors} />
    </div>
  );
}
